import Vue from 'vue'
import Vuex from 'vuex'
import ProductModule from './modules/product'
import UtilityModule from './modules/utility'
import NavigatoryModule from './modules/navigator'
Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [],
	modules: {
		Product: ProductModule,
		Utility: UtilityModule,
		Navigator: NavigatoryModule
	},
	state: {
	},
	mutations: {
	},
	actions: {
	}
})
